import Bryllupshelgen from "./Bryllupshelgen";

export default Bryllupshelgen;
